import $ = require("jquery");

import features = require("diy/util/features");

import NotificationApi from "diy/toolbar/notificationNG/Api";
import NotificationType from "diy/toolbar/notificationNG/definitions/Type";
import {NotificationState} from "../toolbar/notificationNG/definitions/Config";
import {BrowserUpgradePayload} from "../toolbar/notificationNG/types/BrowserUpgrade";

type BrowserUpgradeData = {
    doNotShow: boolean;
    counter: number;
    counterMax: number;
};

export class App {
    private browserVersionIE = 10;
    private browserVersionFirefox = 20;

    init() {

        /** No Browser check if we are on mobile */
        if (!features("browserUpgrade") || ('ontouchend' in document)) {
            this.updateNotification(false);
        }

        /** Gets the message / link to show  depending on the upgrade */
        switch (true) {

            /** IE */
            case $.browser.msie:
                if (parseInt($.browser.version, 10) < this.browserVersionIE) {
                    this.updateNotification(true, 'upgrade', 'ie');

                } else {
                    this.updateNotification(false);
                    return;
                }
                break;

            /** Firefox */
            case $.browser.mozilla:
                if (parseInt($.browser.version, 10) < this.browserVersionFirefox) {
                    this.updateNotification(true, 'upgrade', 'firefox');

                } else {
                    this.updateNotification(false);
                    return;
                }
                break;

            /** Chrome + Safari */
            case $.browser.webkit:
                this.updateNotification(false);
                break;

            /** Others */
            default:
                this.updateNotification(true, 'switch', 'firefox');
                break;
        }
    }

    updateNotification(show: boolean, msgType?: string, browserType?: string) {
        let payload = features.getPayload<BrowserUpgradeData>("browserUpgrade");

        if (!show) {
            NotificationApi.schedule(function () {
                NotificationApi.deleteOne(
                    NotificationType.BROWSER_UPGRADE
                );
            });

        } else if (!payload.doNotShow) {
            NotificationApi.schedule(() => {
                let notificationPayload: BrowserUpgradePayload = {
                    browserType: browserType,
                    msgType: msgType
                };
                let notificationObject: NotificationState = {
                    type: NotificationType.BROWSER_UPGRADE,
                    deleted: false,
                    payload: notificationPayload
                };
                if (payload.counter >= payload.counterMax) {
                    notificationObject.dismissed = false;
                }
                NotificationApi.pushOne(notificationObject);
            });
        }
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/browser-upgrade/App.ts
 **/